<template>
<div>
  <div class="pt-2 md:pt-1 pb-1 px-1 mt-0 h-auto fixed w-full z-20 top-0">
    <div class="flex flex-wrap items-center">
      <v-layout row>
        <v-flex xs4 sm4 md3>
          <v-text-field
              v-model="searchFilter"
              append-icon="search"
              label="Search"
              single-line
          ></v-text-field>
        </v-flex>
      </v-layout>
    </div>
  </div>
  <div class="mt-20 flex-1">
    <div class="grid grid-cols-5 w-full">
      <h2 class="text-2xl col-span-1">Patients</h2>
      <button class="col-span-4 self-center max-w-sm border border-gray-700 bg-gray-400 hover:bg-gray-700 text-lg hover:text-gray-100 hover:shadow-md rounded-sm py-1 ml-4" @click="newPatient">Create New Patient</button>
    </div>
    <div class="patient-grid" v-if="!identified">
      <patient-card
        v-for="(patient, index) in filteredDeIdentPatients"
        :key="index"
        :patient="patient"
        class="patient-card">
      </patient-card>
    </div>
    <div class="patient-grid" v-else>
      <patient-card-ident
        v-for="(patient, index) in filteredPatients"
        :key="index"
        :patient="patient"
        class="patient-card">
      </patient-card-ident>
    </div>
  </div>
</div>

</template>

<script>
import PatientCard from '@/components/PatientCard.vue'
import PatientCardIdent from '@/components/PatientCardIdent.vue'

export default {
  data: () => ({
    identified: true,
    patients: [],
    searchFilter: ''
  }),
  computed: {
    filteredDeIdentPatients () {
      if (!this.searchFilter.length > 0) return this.patients
      return this.patients.filter(patient => {
        const searchLength = this.searchFilter.length
        return this.searchFilter === patient.identifier[0].value.substring(0, searchLength)
      })
      // if (!isNaN(parseFloat(this.searchFilter))) {
      //   return this.patients.filter(patient => patient.identifier[1].value.includes(this.searchFilter))
      // } else {
      //   return this.patients.filter((patient) => {
      //     return patient.name.family.includes(this.searchFilter)
      //   })
      // }
    },
    filteredPatients () {
      if (!this.searchFilter.length > 0) return this.patients
      else if (!isNaN(parseFloat(this.searchFilter))) {
        return this.patients.filter(patient => {
          const searchLength = this.searchFilter.length
          return this.searchFilter === patient.identifier[0].value.substring(0, searchLength)
        })
      }
      return this.patients.filter(patient => patient.name[0].family.toLowerCase().indexOf(this.searchFilter.toLowerCase()) > -1)
      // if (!isNaN(parseFloat(this.searchFilter))) {
      //   return this.patients.filter(patient => patient.identifier[1].value.includes(this.searchFilter))
      // } else {
      //   return this.patients.filter((patient) => {
      //     return patient.name.family.includes(this.searchFilter)
      //   })
      // }
    }
  },
  components: { PatientCard, PatientCardIdent },
  async created () {
    const results = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/patients`)
    this.patients = results.data
  },
  methods: {
    newPatient () {
      this.$router.push({ name: 'patient-edit', params: { patientId: 'new' } })
    }
  }
}
</script>

<style scoped>
.patient-grid {
  width: 100%;
}
.patient-card {
  float: left;
  margin: 20px 20px 0 0;
}
</style>
